var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.45 20.25h8.1v8.1h-8.1v-8.1zm0 16.2h8.1v24.3h-8.1v-24.3zM40.5 0C18.144 0 0 18.144 0 40.5S18.144 81 40.5 81 81 62.856 81 40.5 62.856 0 40.5 0zm0 72.9c-17.86 0-32.4-14.54-32.4-32.4S22.64 8.1 40.5 8.1s32.4 14.54 32.4 32.4-14.54 32.4-32.4 32.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.316b5fbe094166061b726b2cf797d4c7.svg";
export { ForwardRef as ReactComponent };